@if (!!notification) {
  <topo-modal
    [isActive]="!!notification"
    [isCard]="true"
    [headerIsFullWidth]="true"
    [noBodyPadding]="true"
    [rawWidth]="'80vw'"
    [rawHeight]="'75vh'"
    (close)="close()">
    <div class="modal-header header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div
          class="header"
          fxLayout="row"
          fxLayoutAlign="start center">
          <img src="assets/images/purple_bullhorn.svg" />
          <div class="title">{{ notification.name }}</div>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="end center"
          class="mr-3 save-buttons">
          <div
            class="dialog-close ml-2 header-close"
            (click)="close()">
            <i class="icon icon-close-X"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="log-list-page">
        <topo-data-table-server
          #table
          [isActive]="true"
          [tableHidden]="isTableLoading"
          [datasource]="datasource"
          [columns]="columDefs"
          headerLabel="{{ 'COMMUNICATIONS.BUTTONS.EXCEPTION-LOG' | translate }}"
          [headerIcon]=""
          [showNewButton]="false"
          [embedded]="true"
          [rawHeight]="'calc(75vh - 368px)'"
          [rowHeight]="56"
          [showHeader]="true"
          [showSearch]="true"
          [showMenu]="true"
          [autoFitColumns]="false"
          [getRowId]="getRowId"
          [showRowGroups]="false"
          [showSystemFields]="true"
          [enableInfiniteScroll]="false"
          [enableServerSort]="true"
          [enableServerFilter]="true"
          [hidePageLinks]="true"
          (paginate)="onPaginate($event)"
          (takeChanged)="onTakeChanged($event)"
          (sort)="onSortChanged($event)"
          (storeUpdatedCalled)="onGridDataLoaded()"
          (searchFilterChanged)="onSearchFilterChanged($event)"
          (exportToExcel)="onExportToExcel($event)"
          [skip]="skip"
          [take]="take"
        [totalCount]="totalCount"></topo-data-table-server>
      </div>
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="mt-4 mb-4">
        <div></div>
        <div fxLayoutAlign="start">
          <div style="margin-right: 5px">
            <button
              class="button is-secondary"
              (click)="close()">
              {{ 'COMMUNICATIONS.BUTTONS.CLOSE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </topo-modal>
}

<topo-comms-log-status-detail
  [notification]="notification"
  [document]="statusDocument"
  [title]="statusTitle"
(statusClosed)="onStatusClosed()"></topo-comms-log-status-detail>
